import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SVGArrowRight, SVGArrowRightLong } from '../components/SVG';

export function CardHeader({heading, to = null, icon: Icon = null, emoji = null}){
    const navigate = useNavigate();

    const handleClick = () => {
        if (to) {
            navigate(to);
        }
    };

    return (
        <div className='flex relative items-center gap-3 px-2' onClick={handleClick}>
            {Icon &&
                <div className='block relative bg-teal-500/20 rounded-full h-8 w-8 shrink-0'>
                    <Icon classes={`h-4 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] fill-teal-600`} />
                </div>
            }
            {emoji &&
                <div className='block relative text-[1.7rem] leading-[1em] line h-auto w-auto shrink-0'>
                    {emoji}
                </div>
            }
            <span className='text-lg font-bold w-full text-slate-950 dark:text-white'>{heading}</span>
            {to &&
                <div className='block relative h-8 w-8 shrink-0'>
                    <SVGArrowRight classes={`h-5 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] fill-slate-950 dark:fill-white opacity-70`} />   
                </div>
            }
        </div>
    );
}

export function Card({children}){
    return (
        <div className='flex flex-col gap-4 relative bg-white dark:bg-slate-950 px-4 py-5 rounded-2xl ring-1 ring-black/10 dark:ring-white/10 ring-inset shadow-xl shadow-black/5'>
            {children}
        </div>
    );
}